import { render, staticRenderFns } from "./facebook_accounts_modal.vue?vue&type=template&id=3b91521c&"
import script from "./facebook_accounts_modal.vue?vue&type=script&lang=js&"
export * from "./facebook_accounts_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports